/**
 * Helper to check if value is a File object
 */
export const isFile = (value: unknown): value is File => value instanceof File;

/**
 * Recursively strip File objects from any nested structure
 * Files are replaced with metadata strings like [FILE:filename]
 * This prevents sessionStorage quota exceeded errors and enables proper JSON serialization
 */
export const stripFilesRecursive = (obj: unknown): unknown => {
  if (obj === null || obj === undefined) {
    return obj;
  }

  if (isFile(obj)) {
    return `[FILE:${obj.name}]`;
  }

  if (Array.isArray(obj)) {
    return obj.map(stripFilesRecursive);
  }

  if (typeof obj === 'object') {
    const result: Record<string, unknown> = {};
    Object.keys(obj).forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        result[key] = stripFilesRecursive((obj as Record<string, unknown>)[key]);
      }
    });
    return result;
  }

  return obj;
};
